module.exports = __webpack_public_path__ + "img/world-user-08.b6c64f1a.jpg";